import GMTDateFormatter from './DateFormatter/GMTDateFomatter'
import UTCDateFormatter from './DateFormatter/UTCDateFomatter'

export function formatDateFromDateString (date: string) {
  const dateObj = new Date(GMTDateFormatter.parseDate(date));
  return GMTDateFormatter.formatDate(dateObj);
}

export function formatDateFromTimestamp(date: number) {
  return GMTDateFormatter.formatDateFromTimestamp(date);
}

export function formatUTCDateFromDateString (date: string) {
  const dateObj = new Date(UTCDateFormatter.parseDate(date));
  return UTCDateFormatter.formatDate(dateObj);
}
